// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityAvatars-module__avatar--PwqsW";
var _2 = "#000";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "pfx-CommunityAvatars-module__container--kPpzU";
var _8 = "1140px";
var _9 = "940px";
var _a = "100%";
var _b = "15px";
var _c = "620px";
var _d = "#f53535";
var _e = "rgba(0,0,0,.2)";
var _f = "rgba(255,255,255,.38)";
var _10 = ".38";
var _11 = "rgba(255,255,255,.2)";
var _12 = "#0025ff";
var _13 = "pfx-CommunityAvatars-module__glitch-anim--YklKm";
var _14 = "pfx-CommunityAvatars-module__glitch-anim-2--WENuW";
var _15 = "#f60";
var _16 = "#41ead4";
var _17 = "#2cdd78";
var _18 = "#66ab23";
var _19 = "#f5f5f5";
var _1a = "#c3c3c3";
var _1b = "#ececec";
var _1c = "#252525";
var _1d = "#272727";
var _1e = "#c6c6c5";
var _1f = "#333";
var _20 = "#3c3c3c";
var _21 = "#9c9b9b";
var _22 = "#8c8c8c";
var _23 = "#6f6f6e";
var _24 = "#3c3c3b";
var _25 = "#373737";
var _26 = "#6a6a69";
var _27 = "#6f6f6f";
var _28 = "#9f9e9e";
var _29 = "#282828";
var _2a = "#828181";
var _2b = "#1d1d1d";
var _2c = "#979797";
var _2d = "#9c9b9b";
var _2e = "#a7a7a6";
var _2f = "#c6c6c5";
var _30 = "#d8d8d7";
var _31 = "#dddddc";
var _32 = "72px";
var _33 = "40px";
var _34 = "36px";
var _35 = "25px";
var _36 = "18px";
var _37 = "13px";
var _38 = "pfx-CommunityAvatars-module__inner-container--YtUpP";
var _39 = "#0025ff";
var _3a = "rgba(255,255,255,.12)";
var _3b = "#6535f5";
var _3c = "2px";
var _3d = "56px";
var _3e = "56px";
var _3f = "pfx-CommunityAvatars-module__more-count--Zrn4z";
var _40 = "#41ead4";
var _41 = "#f60";
var _42 = "#f83600";
var _43 = "#881f00";
var _44 = "18px";
var _45 = "15px";
var _46 = "red";
var _47 = "pfx-CommunityAvatars-module__small-avatar--xHPjT";
var _48 = "pfx-CommunityAvatars-module__small-inner-container--ekttw";
var _49 = "13px";
var _4a = "rgba(255,255,255,.07)";
var _4b = "#35465c";
var _4c = "#55acee";
var _4d = "#fff";
var _4e = "#ffce36";
var _4f = "#ffcd00";
var _50 = "red";
export { _1 as "avatar", _2 as "black", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "container", _8 as "containerLarge", _9 as "containerMedium", _a as "containerMobile", _b as "containerPaddingMobile", _c as "containerSmall", _d as "danger", _e as "darkElement", _f as "disabled", _10 as "disabledOpacity", _11 as "extraLightElement", _12 as "facebook", _13 as "glitchAnim", _14 as "glitchAnim2", _15 as "google", _16 as "green", _17 as "green2", _18 as "greenColor", _19 as "grey1", _1a as "grey10", _1b as "grey2", _1c as "grey25", _1d as "grey27", _1e as "grey3", _1f as "grey33", _20 as "grey3C", _21 as "grey4", _22 as "grey41", _23 as "grey5", _24 as "grey6", _25 as "grey61", _26 as "grey6A", _27 as "grey6F", _28 as "grey7", _29 as "grey8", _2a as "grey82", _2b as "grey9", _2c as "grey97", _2d as "grey9C", _2e as "greyA7", _2f as "greyC6", _30 as "greyD8", _31 as "greyDd", _32 as "header1", _33 as "header2", _34 as "header3", _35 as "header4", _36 as "header5", _37 as "header6", _38 as "innerContainer", _39 as "klein", _3a as "lightElement", _3b as "lilac", _3c as "menuBorder", _3d as "menuHeight", _3e as "menuMobileHeight", _3f as "moreCount", _40 as "ocean", _41 as "orange", _42 as "orange2", _43 as "orangeDark", _44 as "paragraph", _45 as "paragraphSmall", _46 as "red", _47 as "smallAvatar", _48 as "smallInnerContainer", _49 as "subHeaderSmall", _4a as "subtleLightElement", _4b as "tumblr", _4c as "twitter", _4d as "white", _4e as "yellow", _4f as "yellowDeep", _50 as "youtube" }
